import React, { useState } from 'react';

// Small info "ⓘ" icon that shows a popup with explanatory text on hover or tap.
// `align` controls which way the popup opens so it doesn't run off-screen:
// 'center' (default), 'left' (opens rightward — for icons near the left edge),
// 'right' (opens leftward — for icons near the right edge).
const InfoTooltip = ({ text, width = 240, align = 'center' }) => {
  const [open, setOpen] = useState(false);

  const popupPos =
    align === 'left' ? { left: 0, transform: 'none' }
    : align === 'right' ? { right: 0, transform: 'none' }
    : { left: '50%', transform: 'translateX(-50%)' };
  const arrowPos =
    align === 'left' ? { left: '12px', transform: 'none' }
    : align === 'right' ? { right: '12px', transform: 'none' }
    : { left: '50%', transform: 'translateX(-50%)' };

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <span
        role="button"
        tabIndex={0}
        aria-label="More information"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen((o) => !o); } }}
        style={{
          cursor: 'help',
          color: 'var(--textSecondary)',
          fontSize: '13px',
          lineHeight: 1,
          userSelect: 'none',
        }}
      >
        ⓘ
      </span>

      {open && (
        <span
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 8px)',
            ...popupPos,
            background: '#333',
            color: '#fff',
            padding: '8px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: 400,
            width: `${width}px`,
            maxWidth: '70vw',
            zIndex: 100,
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            lineHeight: 1.45,
            textAlign: 'left',
            whiteSpace: 'normal',
          }}
        >
          {text}
          <span
            style={{
              position: 'absolute',
              top: '100%',
              ...arrowPos,
              borderWidth: '5px',
              borderStyle: 'solid',
              borderColor: '#333 transparent transparent transparent',
            }}
          />
        </span>
      )}
    </span>
  );
};

export default InfoTooltip;
